var e={exports:{}};export{e as __module};
//# sourceMappingURL=core.js.map
